"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasketProvider = exports.BasketContext = void 0;
var react_1 = __importStar(require("react"));
var useLocalStorage_1 = require("../hooks/useLocalStorage");
exports.BasketContext = react_1.createContext({});
var BasketProvider = function (_a) {
    var catalogueId = _a.catalogueId, children = _a.children, propsBasket = _a.basket, _b = _a.noLocalStorage, noLocalStorage = _b === void 0 ? false : _b;
    var _c = useLocalStorage_1.useLocalStorage("_local_basket", propsBasket), localBasket = _c[0], setLocalBasket = _c[1], clearLocalBasket = _c[2];
    var _d = react_1.useState(noLocalStorage ? undefined : localBasket), basket = _d[0], setBasket = _d[1];
    var state = {
        basket: basket,
        setBasket: setBasket,
        catalogueId: catalogueId,
    };
    react_1.useEffect(function () {
        if (noLocalStorage)
            return;
        if (basket) {
            setLocalBasket(basket);
        }
        else {
            clearLocalBasket();
        }
    }, [basket]);
    return (react_1.default.createElement(exports.BasketContext.Provider, { value: state }, typeof children === "function" ? children(state) : children));
};
exports.BasketProvider = BasketProvider;
